import { BaseEntity } from "@app/common";
import { Column, Display, TableColumnType } from "@messaia/cdk";
import { PhoneNumberPortingStatus } from "../enums/phone-number-porting-status";
import { PhoneNumberStatus } from "../enums/phone-number-status";

export class PhoneNumberBlock extends BaseEntity {
    /**
     * @property
     */
    public countryCode: string;

    /**
     * @property
     */
    @Column({
        type: TableColumnType.TextInput,
        maxWidth: 90,
        disable: (row: PhoneNumberBlock) => row.portingStatus == PhoneNumberPortingStatus.Confirmed
    })
    @Display($localize`:@@phoneNumberPrefix:Phone number prefix`)
    public nationalDestinationCode: string;

    /**
     * @property
     */
    @Column({
        type: TableColumnType.TextInput,
        maxWidth: 90,
        disable: (row: PhoneNumberBlock) => row.portingStatus == PhoneNumberPortingStatus.Confirmed
    })
    @Display($localize`:@@extensionNumber:Extension number`)
    public extensionNumber: string;

    /**
     * @property
     */
    @Column({
        type: TableColumnType.TextInput,
        maxWidth: 90,
        disable: (row: PhoneNumberBlock) => row.portingStatus == PhoneNumberPortingStatus.Confirmed
    })
    @Display($localize`:@@answeringStation:Answering station`)
    public answeringStation: string;

    /**
     * @property
     */
    @Column({
        type: TableColumnType.TextInput,
        maxWidth: 100,
        disable: (row: PhoneNumberBlock) => row.portingStatus == PhoneNumberPortingStatus.Confirmed
    })
    @Display($localize`:@@blockStart:Block start`)
    public blockStart: string;

    /**
     * @property
     */
    @Column({
        type: TableColumnType.TextInput,
        maxWidth: 100,
        disable: (row: PhoneNumberBlock) => row.portingStatus == PhoneNumberPortingStatus.Confirmed
    })
    @Display($localize`:@@blockEnd:Block end`)
    public blockEnd: string;

    /**
     * @property
     */
    @Column({ enumType: PhoneNumberStatus, showGtSm: true })
    @Display($localize`:@@status:Status`)
    public status: PhoneNumberStatus = PhoneNumberStatus.Pending;

    /**
     * @property
     */
    @Column({ enumType: PhoneNumberPortingStatus, showGtSm: true })
    @Display($localize`:@@portingStatus:Porting status`)
    public portingStatus: PhoneNumberPortingStatus = PhoneNumberPortingStatus.New;

    /**
     * @property
     */
    public portingStatusDate: string | null;

    /**
     * @property
     */
    public selected: boolean;

    /**
     * @property
     */
    public count: number;

    /**
     * constructor
     * @param init 
     */
    public constructor(init?: Partial<PhoneNumberBlock>) {
        super(init);
        Object.assign(this, init);
    }
}